import React from 'react';
import { useNavigate } from 'react-router-dom';

import { BaseButton, useIsMobile, useT } from '@repo/common';

const HeroBottom = () => {
  const t = useT();
  const navigate = useNavigate();
  const isMobile = useIsMobile();
  const heroBottom = `${process.env.REACT_APP_ASSETS_URL}/Career/img-bottom-kpassport.svg`;

  return (
    <div className='w-full flex flex-col items-center px-4 tabletH:px-10 gap-4 tabletH:gap-6'>
      <div
        className='w-full max-w-[1166px] flex flex-row items-center justify-between p-4 tabletH:p-6 gap-2 rounded-[8px] 
              ring-1 ring-grayscale-gray02'
        style={{
          background:
            'linear-gradient(0deg, rgba(236, 233, 228, 0.50) 0%, rgba(236, 233, 228, 0.50) 100%), #F9F7F4',
        }}
        onClick={() => navigate('/career/resumes/guide')}
      >
        <div>
          <div className='typo-b14Strong tabletH:typo-title3 text-text-tertiary'>
            {t('New to resume in Korea?', '한국 이력서가 처음이신가요?')}
          </div>
          <div className='typo-b12 tabletH:typo-b14 text-text-tertiary'>
            {t(
              'Learn what employers expect and how to structure your resume.',
              '기업이 기대하는 것과 이력서 구성 방법을 알아보세요.',
            )}
          </div>
        </div>
        <BaseButton
          type='text'
          size='s'
          hideIcon
          width={isMobile ? '55px' : 'auto'}
          bgclass='bg-grayscale-gray02 px-2.5 py-1.5 border-none z-10'
          hoverclass='hover:bg-grayscale-gray02 hover:text-grayscale-gray09'
          activeclass='active:bg-grayscale-gray02 active:text-grayscale-gray09'
          textclass='typo-b12Strong'
        >
          {isMobile ? t('Guide', '가이드') : t('Read the guide', '가이드 보기')}
        </BaseButton>
      </div>
      <div
        className='relative w-full max-w-[1166px] rounded-[8px]'
        onClick={() => navigate('/pathfinder')}
      >
        <div
          className='w-full flex flex-row items-center justify-between p-4 tabletH:p-6 gap-2 rounded-[8px] 
                    bg-green-light01 ring-1 ring-surface-lightgray60'
          style={{
            background: `linear-gradient(0deg, rgba(249, 247, 244, 0.80) 0%, rgba(249, 247, 244, 0.80) 100%), url(${heroBottom}) 0% 52% / cover no-repeat, #EDFCF7`,
          }}
        >
          <div>
            <div className='relative z-10'>
              <div className='typo-b14Strong tabletH:typo-title3 text-text-tertiary'>
                {t(
                  'Career gap diagnosis, Pathfinder',
                  '커리어 갭 진단, Pathfinder',
                )}
              </div>
            </div>
          </div>
          <BaseButton
            type='text'
            size='s'
            hideIcon
            width={isMobile ? '55px' : 'auto'}
            bgclass='bg-surface-lightgray80 px-2.5 py-1.5 border-none z-10'
            hoverclass='hover:bg-surface-lightgray80 hover:text-grayscale-gray09'
            activeclass='active:bg-surface-lightgray80 active:text-grayscale-gray09'
            textclass='typo-b12Strong'
          >
            {isMobile
              ? t('Start', '시작')
              : t('Start Pathfinder', 'Pathfinder 시작하기')}
          </BaseButton>
        </div>
      </div>
    </div>
  );
};

export default HeroBottom;
